import React, { forwardRef } from 'react'

import { Loader } from '@elamajs/ui-kit'

import * as Styled from './Button.styled'
import { Props, Size, StaticProps, Variant, Width } from './Button.types'

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      size = Size.LARGE,
      variant = Variant.BLUE,
      width = Width.NARROW,
      isLoading,
      children,
      type,
      ...buttonProps
    },
    ref
  ) => (
    <Styled.Button
      ref={ref}
      size={size}
      variant={variant}
      width={width}
      type={type ?? 'button'}
      {...buttonProps}
    >
      {isLoading ? (
        <Styled.Loader isDisabled={buttonProps.disabled} as={Loader} />
      ) : (
        <>
          <span>{children}</span>
        </>
      )}
    </Styled.Button>
  )
)

Button.displayName = 'Button'

const ButtonWithStaticProps = Object.assign({}, Button, {
  Size: Size,
  Variant: Variant,
  Width: Width
} as StaticProps)

export default ButtonWithStaticProps
